import React from 'react';
import { CodeIcon, SmartphoneIcon, GlobeIcon, CpuIcon, LayersIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const technologies = [{
  icon: GlobeIcon,
  label: 'Google'
}, {
  icon: CpuIcon,
  label: 'Gemini'
}, {
  icon: SmartphoneIcon,
  label: 'PWA'
}, {
  icon: CodeIcon,
  label: 'React'
}, {
  icon: LayersIcon,
  label: 'TypeScript'
}];
export function TrustBar() {
  const revealRef = useScrollReveal();
  return <section ref={revealRef} aria-label="Technológie" className="py-12 border-y border-gray-100 bg-apple-light/60" data-id="element-493" data-mp="1qva8mqpfo2o0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-494" data-mp="1gz78tri20g48">
        <p className="reveal text-center text-xs font-semibold tracking-[0.2em] text-apple-gray uppercase mb-8" data-id="element-495" data-mp="1gyp8ojs9thr1">
          Technológie, ktorým dôverujeme
        </p>
        <ul className="reveal reveal-delay-1 flex flex-wrap justify-center items-center gap-x-10 gap-y-6 md:gap-x-16" data-id="element-496" data-mp="5jsc8otrbq9n">
          {technologies.map(tech => <li key={tech.label} className="flex items-center gap-2.5 text-gray-600" data-id="element-497" data-mp="agsc2i00jwsb">
              <tech.icon className="w-5 h-5" aria-hidden="true" data-id="element-498" data-mp="1akzx40q1ijw2" />
              <span className="font-bold text-lg tracking-tight" data-id="element-499" data-mp="16in14413i0ch">{tech.label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}